var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "router-link",
    {
      attrs: {
        to: {
          name: "profile_access"
        }
      }
    },
    [
      _vm.service.sharedaccess
        ? [_vm._v(" Enabled ")]
        : [_vm._v(" Shared With Me ")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }